import React, { Component } from 'react';
import {
  AlertBackground,
  AlertContainer,
  AlertClose,
  AlertContent,
  AlertFooter,
} from './style';
import Header from '../Header';
import Button from '../Button';
import IconClose from '../../assets/img/alert-ic-close.png';

const RenderData = props => {
  const { id, usuario } = props;
  return <option key={id} value={usuario} />;
};

class Alert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    this.setState({
      data: [
        { id: 1, usuario: 'sergio.vieira' },
        { id: 2, usuario: 'kelson.maciel' },
      ],
    });
  }

  render() {
    const { onClose, onClick } = this.props;
    return (
      <AlertBackground>
        <AlertContainer>
          <AlertClose onClick={onClose}>
            <img src={IconClose} alt="" />
          </AlertClose>
          <Header
            title="Identificação"
            subtitle="Preencha os campos para a sua identifiação"
            center
          />
          <AlertContent>
            <form action="">
              <div>
                <div>
                  <input
                    list="usuarios"
                    name="usuarios"
                    placeholder="Usuário"
                    autoFocus
                  />
                </div>
                <datalist id="usuarios">
                  {this.state.data.map(({ id, usuario }) => (
                    <RenderData key={id} usuario={usuario} />
                  ))}
                </datalist>
              </div>
              <div>
                <input type="password" name="senha" placeholder="Senha" />
              </div>
            </form>
          </AlertContent>
          <AlertFooter>
            <Button onClick={onClick}>Confirmar</Button>
          </AlertFooter>
        </AlertContainer>
      </AlertBackground>
    );
  }
}

export default Alert;
